import React from 'react';
import AppContext from '../AppContext';
import { getCurrentOrder } from '../selectors';
import styles from './CurrentOrderInfo.module.scss';

const CurrentOrderInfo = () => {
  const context = React.useContext(AppContext);

  const currentOrder = getCurrentOrder(context);

  if (currentOrder == null) {
    return <></>;
  }
  const { doc } = currentOrder;

  if (doc == null) {
    return <></>;
  }

  if (doc.status === 'done') {
    return <></>;
  }

  return (
    <>
      <div className={styles.currentOrderId}>{doc.id}</div>
    </>
  );
};

export default CurrentOrderInfo;
